let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8gQKz"), load("ctZCD"), load("7Q0UC"), load("6m2wP")]).then(() => parcelRequire('h3wNo'));